var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.3108 3.49999L6.81079 7.99999L11.3108 12.5L10.2501 13.5607L4.68947 7.99999L10.2501 2.43933L11.3108 3.49999Z","fill":"#181818"}));
}

Back.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Back;

Back.default = Back;
